// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2UQ9N","productName":"Table_productName__3rnY0"};